import React, { useContext } from 'react'
import { Pane, Button, majorScale } from 'evergreen-ui'
import { NavigationBar, NavigationBarTitle } from 'evergreen-draft'
import { Link as RouterLink } from 'react-router'
import { WorkspaceContext } from 'context/WorkspaceContext'
import UserDropdownApp from 'containers/Navigation/UserDropdownApp'
import OmnisearchApp from 'containers/Omnisearch/OmnisearchApp'
import NotificationCenterApp from 'containers/NotificationCenter'

interface Props {
  hasBackButton?: boolean
  backButtonLabel?: string
  backButtonLink?: string
  title: string
  titleLink?: string
  subtitle?: string
}

const TopBar: React.FC<Props> = ({
  hasBackButton = false,
  backButtonLabel,
  backButtonLink,
  title,
  titleLink,
  subtitle
}) => {
  const { workspaceId, workspaceSlug } = useContext(WorkspaceContext)

  return (
    <NavigationBar
      leftView={
        hasBackButton ? (
          <Button is={RouterLink} to={backButtonLink} iconBefore="arrow-left">
            {backButtonLabel}
          </Button>
        ) : (
          undefined
        )
      }
      centerView={
        <Pane display="flex" alignItems="center">
          {subtitle ? (
            <NavigationBarTitle
              parent={
                <NavigationBarTitle is={titleLink ? RouterLink : undefined} to={titleLink}>
                  {title}
                </NavigationBarTitle>
              }
            >
              {subtitle}
            </NavigationBarTitle>
          ) : (
            <NavigationBarTitle is={titleLink ? RouterLink : undefined} to={titleLink}>
              {title}
            </NavigationBarTitle>
          )}
        </Pane>
      }
      rightView={
        <>
          <Pane marginRight={majorScale(2)}>
            <OmnisearchApp />
          </Pane>

          {/*
          // @ts-ignore */}
          <NotificationCenterApp workspaceId={workspaceId} workspaceSlug={workspaceSlug} />

          <UserDropdownApp />
        </>
      }
    />
  )
}

export default TopBar
